import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import React from 'react'

import styles from './LoadingIndicatorButton.module.sass'

const LoadingIndicatorButton = (props) => {
	const { className, label, ...attributes } = props
	const { i18n } = useGlobal()
	return (
		<div
			className={`${styles['loading-indicator-button']} ${styles['inline']} ${className || ''}`}
			{...attributes}
		>
			<Icon className={styles['action-icon']} name='on-going' size="small" />
			<small>{label ?? i18n`Loading`}</small>
		</div>
	)
}

export default LoadingIndicatorButton
